import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { ProviderWithIntegrationDetailFragmentDoc } from '../../fragments/generated/ProviderWithIntegrationDetail';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetProvidersWithIntegrationDetailsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.GetProvidersFilters>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
}>;


export type GetProvidersWithIntegrationDetailsQuery = { providers: { success: boolean, totalCount: number, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, name: string, url: string, logo: { url?: string | null }, integrationProvider?: { id: string, provider: Types.IntegrationProviderEnum, integrationDetail?: { id: string, status: Types.IntegrationStatusEnum } | null } | null } }> | null } };


export const GetProvidersWithIntegrationDetailsDocument = /*#__PURE__*/ gql`
    query getProvidersWithIntegrationDetails($filters: GetProvidersFilters, $first: Float, $after: String, $sort: [SortType!]) {
  providers(sort: $sort, filters: $filters, first: $first, after: $after) {
    success
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...ProviderWithIntegrationDetail
      }
    }
  }
}
    ${ProviderWithIntegrationDetailFragmentDoc}`;

export function useGetProvidersWithIntegrationDetailsQuery(options?: Omit<Urql.UseQueryArgs<GetProvidersWithIntegrationDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProvidersWithIntegrationDetailsQuery, GetProvidersWithIntegrationDetailsQueryVariables>({ query: GetProvidersWithIntegrationDetailsDocument, ...options });
};